import { Check } from 'lucide-react';
import { cn } from 'helpers/cn';
import { CommandGroup, CommandItem } from '@/components/ui/command';

export type ObjectiveSection = { heading: string; names: readonly string[] };

type ObjectiveCommandGroupsProps = {
  sections: readonly ObjectiveSection[];
  onPick: (name: string) => void;
  /** Shows a check mark against this name. */
  selected?: string | null;
  /** A name listed but not pickable, with a short reason shown beside it. */
  disabled?: { name: string; reason: string } | null;
};

/** The mapped and not-mapped events as Command groups, skipping any empty section. */
export const ObjectiveCommandGroups = ({ sections, onPick, selected, disabled }: ObjectiveCommandGroupsProps) => (
  <>
    {sections.map(({ heading, names }) =>
      names.length ? (
        <CommandGroup key={heading} heading={heading}>
          {names.map((name) => {
            const isDisabled = disabled?.name === name;
            return (
              <CommandItem key={name} value={name} disabled={isDisabled} onSelect={() => onPick(name)}>
                <Check className={cn('size-4 shrink-0', selected === name ? 'opacity-100' : 'opacity-0')} />
                <span className="truncate">{name}</span>
                {isDisabled ? <span className="supporting ml-auto shrink-0">{disabled.reason}</span> : null}
              </CommandItem>
            );
          })}
        </CommandGroup>
      ) : null,
    )}
  </>
);
